// ------------------------------------------------------------------------------
// name: types
// author: mudas
// created: 2025/3/5
// ------------------------------------------------------------------------------

/*
  CHINA_ID_CARD = (0, "中华人民共和国居民身份证")
  HONGKONG_MACAO_PASS = (1, "港澳居民来往内地通行证")
  HONGKONG_MACAO_RESIDENCE = (2, "港澳居民居住证")
  TAIWAN_PASS = (3, "台湾居民来往大陆通行证")
  TAIWAN_RESIDENCE = (4, "中华人民共和国台湾居民居住证")
  CHINA_PASSPORT = (5, "中国护照")
  FOREIGN_PASSPORT = (6, "外国护照")
  FOREIGN_RESIDENCE_PERMIT = (7, "外国人永久居留身份证")
  FOREIGN_WORK_PERMIT_A = (8, "中华人民共和国外国人工作许可证(A类)")
  FOREIGN_WORK_PERMIT_B = (9, "中华人民共和国外国人工作许可证(B类)")
  FOREIGN_WORK_PERMIT_C = (10, "中华人民共和国外国人工作许可证(C类)")
  OTHER = (11, "其他个人证件")
 */

// 实名认证类型
export enum CertificateType {
  // 中华人民共和国居民身份证
  CHINA_ID_CARD = 0,

  // 港澳居民来往内地通行证
  HONGKONG_MACAO_PASS = 1,

  // 港澳居民居住证
  HONGKONG_MACAO_RESIDENCE = 2,

  // 台湾居民来往大陆通行证
  TAIWAN_PASS = 3,

  // 中华人民共和国台湾居民居住证
  TAIWAN_RESIDENCE = 4,

  // 中国护照
  CHINA_PASSPORT = 5,

  // 外国护照
  FOREIGN_PASSPORT = 6,

  // 外国人永久居留身份证
  FOREIGN_RESIDENCE_PERMIT = 7,

  // 中华人民共和国外国人工作许可证(A类)
  FOREIGN_WORK_PERMIT_A = 8,

  // 中华人民共和国外国人工作许可证(B类)
  FOREIGN_WORK_PERMIT_B = 9,

  // 中华人民共和国外国人工作许可证(C类)
  FOREIGN_WORK_PERMIT_C = 10,

  // 其他个人证件
  OTHER = 11,
}

// 认证类型名称
export const CertificateTypeName: { [key in CertificateType]: string } = {
  [CertificateType.CHINA_ID_CARD]: '中华人民共和国居民身份证',
  [CertificateType.HONGKONG_MACAO_PASS]: '港澳居民来往内地通行证',
  [CertificateType.HONGKONG_MACAO_RESIDENCE]: '港澳居民居住证',
  [CertificateType.TAIWAN_PASS]: '台湾居民来往大陆通行证',
  [CertificateType.TAIWAN_RESIDENCE]: '中华人民共和国台湾居民居住证',
  [CertificateType.CHINA_PASSPORT]: '中国护照',
  [CertificateType.FOREIGN_PASSPORT]: '外国护照',
  [CertificateType.FOREIGN_RESIDENCE_PERMIT]: '外国人永久居留身份证',
  [CertificateType.FOREIGN_WORK_PERMIT_A]: '中华人民共和国外国人工作许可证(A类)',
  [CertificateType.FOREIGN_WORK_PERMIT_B]: '中华人民共和国外国人工作许可证(B类)',
  [CertificateType.FOREIGN_WORK_PERMIT_C]: '中华人民共和国外国人工作许可证(C类)',
  [CertificateType.OTHER]: '其他个人证件',
};
